import { Flex, MentionProps, Mentions } from 'antd'
import { OptionProps } from 'antd/es/select'
import React, { useRef } from 'react'

type Props = {
  id?: string
  value?: string
  initialValues?: string
  onChange?: (value: string) => void
  options: string[]
  propsInput?: MentionProps
}

export const DynamicInput: React.FC<Props> = ({
  id,
  value,
  initialValues,
  onChange,
  options,
  ...props
}) => {
  const mentionsRef = useRef<any>(null) // To access the cursor position

  const handleSelect = (option: OptionProps) => {
    const inputElement = mentionsRef.current?.textarea

    if (inputElement) {
      const cursorPosition = inputElement.selectionStart
      const valueSafe = value ?? ''
      const newValue =
        valueSafe.slice(0, cursorPosition) +
        `${option.value}} ` +
        valueSafe.slice(cursorPosition)

      onChange(newValue)

      // Move cursor after the inserted space
      const newCursorPosition = cursorPosition + option.value.length + 2 // +2 for the `}` and space
      setTimeout(() => {
        inputElement.setSelectionRange(newCursorPosition, newCursorPosition)
        inputElement.focus() // Refocus the input after cursor move
      }, 0)
    }
  }

  return (
    <span id={id}>
      <Flex
        flex={1}
        vertical
        gap={10}
        style={{ textAlign: 'left' }}
        id="tour-chat-input"
      >
        <Mentions
          {...props.propsInput}
          ref={mentionsRef}
          value={value}
          onChange={onChange}
          onSelect={handleSelect}
          style={{ width: '100%', resize: 'none' }}
          placeholder="Type { to see options"
          autoSize={{ minRows: 1, maxRows: 6 }}
          variant="outlined"
          placement="top"
          allowClear
          prefix="{"
          options={options.map(option => ({
            key: option,
            value: option,
            className: 'antd-demo-dynamic-option',
            label: (
              <>
                <div
                  style={{
                    maxWidth: '400px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  title={option}
                >
                  {option}
                </div>
              </>
            ),
          }))}
        />
      </Flex>
    </span>
  )
}
